import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import Ad from '@ifeng/ui_pc_ad';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import Artical from './artical';
import Request from './request';
import Goodbook from './goodbook';

class LeftContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        observer: PropTypes.object,
    };

    render() {
        const { content, observer } = this.props;
        const {
            article,
            article: { searchPath },
            goodbook0,
            contentAd,
            infoAd,
            hardAd,
            serviceAd,
            contentBottomAd,
            commentAd,
        } = content;

        // 佛教无为您推荐内容
        return (
            <div className={styles.leftContent}>
                <Artical content={article} ad={contentAd} commentAd={commentAd} />
                <NoSSR>
                    <div className={styles.space30} />
                    {searchPath.indexOf('16-') === 0 ? null : <Request ad={infoAd} observer={observer} />}
                    <div className={styles.space40} />
                    <div>
                        <Ad content={hardAd} styleName={styles.hardAd} />
                        <Ad content={serviceAd} styleName={styles.serviceAd} />
                        <Ad content={contentBottomAd} styleName={styles.contentBottomAd} />
                    </div>
                    <div className={styles.space25} />
                    {goodbook0 ? (
                        <Chip
                            id="55001"
                            type="recommend"
                            title="正文好书精选"
                            groupName="正文"
                            position="relative"
                            content={goodbook0}
                            translate="handleGoodbookData">
                            <Goodbook observer={observer} />
                        </Chip>
                    ) : (
                        ''
                    )}
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(LeftContent);
